import React from 'react'

import { Helmet } from 'react-helmet'
import { withRouteData } from 'react-static'

import './InnovationWeek.css'

const SESSION_IMAGES = {
  1: 'https://a.storyblok.com/f/42340/1080x1080/a9714d949f/0.jpg',
  2: 'https://a.storyblok.com/f/42340/1080x1080/88454074fd/1.jpg',
  3: 'https://a.storyblok.com/f/42340/1080x1080/d863233bb4/2.jpg  ',
  4: 'https://a.storyblok.com/f/42340/1080x1080/692f5ba183/3.jpg',
  5: 'https://a.storyblok.com/f/42340/1080x1080/f1788531c5/4.jpg',
  6: 'https://a.storyblok.com/f/42340/1080x1080/a4a270b801/5.jpg',
  7: 'https://a.storyblok.com/f/42340/1080x1080/d97651a7c2/liderazgo.jpg',
  8: 'https://a.storyblok.com/f/42340/1080x1080/3d641b91bf/6.jpg',
  9: 'https://a.storyblok.com/f/42340/1080x1080/8b04447787/7.jpg',
  10: 'https://a.storyblok.com/f/42340/1080x1080/f661eb839e/myanmar.jpg',
  11: 'https://a.storyblok.com/f/42340/1080x1080/720bca3348/10.jpg',
  12: 'https://a.storyblok.com/f/42340/1080x1080/3ead6c0751/12.jpg',
  13: 'https://a.storyblok.com/f/42340/1080x1080/647ce26291/9.jpg',
  14: 'https://a.storyblok.com/f/42340/1080x1080/33a26ca115/aspen.jpg',
  15: 'https://a.storyblok.com/f/42340/1080x1080/72bec6c4fc/11.jpg',
}

const AGENDA = [
  {
    date: 'Lunes 6 de julio',
    sessions: [
      {
        title: 'Ceremonia de Apertura de la Semana de la Innovación',
        imageNumber: 1,
        time: '9:00 AM ET / 10:00 PYT',
        description:
          '¡Bienvenidos a Poverty Stoplight Innovation Week! La ceremonia de apertura incluirá una conversación íntima con el Dr. Martín Burt, fundador y director ejecutivo de la Fundación Paraguaya y del Poverty Stoplight, en diálogo con Rodrigo París, agente de cambio social en América Latina, filántropo y periodista.\n\nSesión en español con traducción en vivo al inglés.',
        registerHref: 'https://luma.com/k6kopru1',
      },
      {
        title: 'Tecnología Cívica e Impacto Social',
        imageNumber: 2,
        time: '11:00 AM ET / 12:00 PYT',
        description:
          'Esta sesión explora cómo la tecnología cívica puede impulsar la transparencia, la rendición de cuentas y un impacto social medible.\n\nContará con la participación de Oluseun Onigbinde, cofundador de BudgIT y destacado defensor de la transparencia fiscal, la gobernanza abierta y la participación ciudadana en África, junto a Julia Corvalan, PhD, gerente de operaciones globales del Poverty Stoplight y experta en desarrollo internacional enfocada en escalar tecnologías sociales en comunidades vulnerables.\n\nLa conversación analizará cómo las herramientas digitales pueden empoderar a los ciudadanos, fortalecer las instituciones y respaldar el cambio impulsado por las propias comunidades.\n\nJuntos, los ponentes debatirán sobre lo que se necesita para diseñar tecnología cívica que sea inclusiva, práctica y arraigada en un impacto real, pasando del acceso a los datos a una participación, confianza y rendición de cuentas más profundas.\n\nSesión en inglés con traducción en vivo al español.',
        registerHref: 'https://luma.com/mhgltkk4',
      },
      {
        title:
          'Rendimiento Excesivo, Burnout y Nuestra Sobredependencia de la Tecnología',
        imageNumber: 3,
        time: '1:00 PM ET / 14:00 PYT',
        description:
          'Esta conversación explora el rendimiento excesivo crónico, el agotamiento laboral (burnout) y el papel cada vez mayor de las pantallas, los dispositivos y las herramientas digitales en la forma en que trabajamos, nos esforzamos, nos comparamos y nos desconectamos.\n\nBasándose en los temas de su libro Life. Reclaimed: Find Freedom from Chronic Overperformance, Pippa Grange —psicóloga de rendimiento, entrenadora de cultura, autora y miembro de liderazgo ético que ha trabajado con equipos y profesionales de élite en todo el mundo— reflexionará sobre cómo mantener al ser humano en el centro de la ambición y el éxito.\n\nEn diálogo con Julia Corvalan, PhD, gerente de operaciones globales del Poverty Stoplight y experta en desarrollo internacional enfocada en la innovación de base y la tecnología social, la sesión analizará cómo las personas y las organizaciones pueden alejarse de los patrones insostenibles de sobreexigencia para avanzar hacia formas de vida y trabajo más intencionales, humanas y resilientes.\n\nSesión en inglés con traducción en vivo al español.',
        registerHref: 'https://luma.com/ktt6gfl8',
      },
    ],
  },
  {
    date: 'Martes 7 de julio',
    sessions: [
      {
        title:
          'Un Enfoque Centrado en el Ser Humano y Potenciado por la IA para Combatir la Pobreza',
        imageNumber: 4,
        time: '8:00 AM ET / 9:00 PYT',
        description:
          'Esta sesión explora cómo la inteligencia artificial puede ayudar a transformar el conocimiento en acción, fortalecer la autonomía humana y acelerar el camino hacia el fin de la pobreza extrema.\n\nDe la mano de Zahid Torres-Rahman, de Business Fights Poverty, la conversación se basará en la labor de esta organización como una comunidad global de 30,000 profesionales que promueven la calidad de vida, el sustento y el acceso al aprendizaje.\n\nCon más de 30 años de experiencia construyendo alianzas para el impacto social, Zahid aporta una perspectiva práctica sobre cómo la IA puede fortalecer las relaciones de confianza, el intercambio de conocimientos y la colaboración. La sesión también explorará el desarrollo realizado por la organización en 2025 de herramientas de IA que conectan a las personas con miles de recursos y con una Red Global de Expertos de más de 200 profesionales.\n\nLa conversación analizará cómo la IA puede apoyar la mitigación de la pobreza manteniendo a las personas, su dignidad, su autonomía, su experiencia y sus vivencias en el centro de la estrategia.\n\nSesión en inglés con traducción en vivo al español.',
        registerHref: 'https://luma.com/jl2f2ooz',
      },
      {
        title: 'Innovación en el Poverty Stoplight: Avances y Próximos Pasos',
        imageNumber: 5,
        time: '10:00 AM ET / 11:00 PYT',
        description:
          'Esta sesión de recapitulación destacará las últimas actualizaciones tecnológicas en todo el ecosistema del Poverty Stoplight, incluyendo mejoras en la visualización de datos, el chatbot de IA y la plataforma digital.\n\nGuido Ruiz Díaz y Fabrizio Núñez, de la Fundación Paraguaya, compartirán los avances recientes, los aprendizajes clave y los próximos pasos para fortalecer las herramientas que ayudan a los socios, profesionales y familias a transformar los datos en acciones concretas.\n\nSesión en español con traducción en vivo al inglés.',
        registerHref: 'https://luma.com/6ovjnre9',
      },
    ],
  },
  {
    date: 'Miércoles 8 de julio',
    sessions: [
      {
        title:
          'Tecnología del Poverty Stoplight para Instituciones de Microfinanzas (IMF)',
        imageNumber: 6,
        time: '7:00 AM ET / 8:00 PYT',
        description:
          'Las microfinanzas funcionan mejor cuando forman parte de una estrategia más amplia que ayuda a las familias a desarrollar capacidades, dignidad y autonomía.\n\nEsta sesión explorará cómo la tecnología del Semáforo puede ayudar a las instituciones de microfinanzas a ir más allá de las simples tasas de pago y enfocarse en si las familias están mejorando sus vidas de manera medible.\n\nEn conversación con Larry Reed, de Thrive Lights, Luis Fernando Sanabria, de la Fundación Paraguaya, estará acompañado por Smita Bhatnagar y Salma Kagadi, de SEWA (India), para debatir sobre cómo las herramientas digitales, los datos a nivel del hogar y el acompañamiento centrado en la familia pueden fortalecer los programas de microfinanzas.\n\nJuntos, analizarán cómo las instituciones pueden comprender mejor las realidades multidimensionales de sus clientes, respaldar acciones más focalizadas y utilizar la tecnología para vincular estrechamente la inclusión financiera con la mitigación de la pobreza y el bienestar a largo plazo.\n\nSesión en inglés con traducción en vivo al español.',
        registerHref: 'https://luma.com/kr88bxww',
      },
      {
        title: 'Liderazgo con Propósito en los Negocios y en la Vida',
        imageNumber: 7,
        time: '10:30 AM ET / 11:30 PYT',
        description:
          'Como parte de la Semana de la Innovación del Poverty Stoplight, los invitamos a una conversación íntima con Raúl Gauto, Agente de Cambio Social Paraguayo, Ambientalista y Emprendedor.\n\nSerá entrevistado por Luis Fernando Sanabria, COO de la Fundación Paraguaya. Este intercambio sincero cubrirá la notable trayectoria de Raúl en el espacio de impacto social en América Latina, construyendo ecosistemas y comunidades de cuidado con Avina durante décadas, estableciendo la Reserva Natural del Bosque Mbaracayú en Paraguay con el apoyo de The Nature Conservancy, y más recientemente, llevando el Poverty Stoplight a las cadenas de valor forestal en Paraguay a través de su negocio de triple impacto, Forestal Sylvis. ¡Imperdible!\n\nLa sesión se llevará a cabo en español con traducción simultánea al inglés.',
        registerHref: 'https://luma.com/ppb1fl94',
      },
      {
        title: 'El Enfoque Centrado en el Ser Humano en la Era de la IA',
        imageNumber: 8,
        time: '12:00 PM ET / 13:00 PYT',
        description:
          'A medida que la inteligencia artificial acelera nuevas posibilidades para el desarrollo, la inclusión financiera y la prestación de servicios, esta sesión plantea una pregunta fundamental: ¿cómo nos aseguramos de que la tecnología fortalezca la autonomía humana en lugar de reemplazarla?\n\nEn conversación con Julia Corvalan, del Poverty Stoplight, Eric Kaduru, de CARE USA, explorará lo que significa adoptar un enfoque centrado en el ser humano para la transformación digital en comunidades que históricamente han estado desatendidas por los sistemas formales.\n\nA partir de su labor como Director Técnico Senior de Alianzas Estratégicas, Inclusión Digital y Finanzas Inclusivas, Eric compartirá las claves de su enfoque, el cual parte de la demanda local, la confianza y las realidades comunitarias, para luego diseñar alianzas, sistemas de datos, marcos de identidad y vínculos financieros que puedan escalar sin perder el sentido de pertenencia ni el contexto.\n\nJuntos, Julia y Eric debatirán sobre cómo la IA y las herramientas digitales pueden respaldar ecosistemas económicos inclusivos cuando se diseñan pensando primero en las personas, fortaleciendo la resiliencia, la gobernanza y las oportunidades para las mujeres y las comunidades vulnerables.\n\nSesión en inglés con traducción en vivo al español.',
        registerHref: 'https://luma.com/t6pgyc52',
      },
      {
        title:
          'Modelos de Lenguaje Grandes (LLM) Robustos para Apoyar la Eliminación de la Pobreza',
        imageNumber: 9,
        time: '3:00 PM ET / 16:00 PYT',
        description:
          'La última década ha estado marcada por una disminución en el apoyo y financiamiento para iniciativas en el sector humanitario y de desarrollo, ejemplificada de manera contundente por el desmantelamiento de la USAID a principios de 2025. Estas tendencias han dejado vacíos de conocimiento y financiamiento que resaltan aún más la necesidad de nuevos enfoques para abordar la pobreza global.\n\nImplementamos un enfoque novedoso e integrado para ajustar minuciosamente (finetuning) un modelo de lenguaje grande fundamental utilizando una amplia variedad de datos de desarrollo internacional, con la esperanza de que este trabajo pueda utilizarse como una herramienta de formulación de políticas para fundamentar soluciones más eficaces contra la pobreza y el desarrollo.\n\nRobert Krueger y Esther Mao, del Instituto Politécnico de Worcester (WPI), compartirán el trabajo relacionado con inste^d, una plataforma impulsada por IA diseñada para ayudar a los formuladores de políticas y a las organizaciones de ayuda a comprender mejor la pobreza multidimensional e identificar intervenciones más focalizadas y basadas en evidencia. Aprovechando las fortalezas interdisciplinarias de WPI en ciencias sociales, políticas públicas, ciencia de datos e investigación basada en proyectos, la sesión examinará cómo los modelos de lenguaje grandes y diversos conjuntos de datos de desarrollo internacional pueden respaldar un diagnóstico de la pobreza, un diseño de políticas y una asignación de recursos más eficaces.\n\nEn lugar de depender únicamente de mediciones basadas en los ingresos o en supuestos verticales (de arriba hacia abajo), esta conversación se centrará en cómo la IA puede ayudar a visibilizar patrones, contextos y prioridades comunitarias de manera que se fortalezca la autonomía humana y se mejore la toma de decisiones. Los participantes analizarán tanto la promesa como la responsabilidad de utilizar la IA como una herramienta para la mitigación de la pobreza más receptiva y centrada en el beneficiario.\n\nSesión en inglés con traducción en vivo al español.',
        registerHref: 'https://luma.com/90ykpdwx',
      },
    ],
  },
  {
    date: 'Jueves 9 de julio',
    sessions: [
      // {
      //   title: 'Sesión Especial de Bonificación de VisionFund Myanmar',
      //   imageNumber: 10,
      //   time: '6:00 PYT',
      //   description:
      //     'Una sesión especial de bonificación con Seng Bu Manam, entrevistado por Martin Burt.\n\nSesión en inglés con traducción en vivo al español.',
      //   registerHref: '#',
      // },
      {
        title: 'Nueva Aplicación Móvil del Semáforo',
        imageNumber: 11,
        time: '9:00 AM ET / 10:00 PYT',
        description:
          'Esta sesión práctica presentará a los socios la nueva aplicación móvil del Poverty Stoplight (Stoplight Mobile App), destacando sus mejoras clave y recorriendo el flujo de toma de encuestas y sincronización.\n\nGuido Ruiz Díaz y Fabrizio Núñez, de la Fundación Paraguaya, guiarán a los equipos de implementación a través de los cambios, cómo la aplicación apoya el trabajo de campo y qué deben saber los socios al comenzar a utilizarla.\n\nLa sesión también ofrecerá un espacio para comentarios, preguntas y aprendizaje compartido entre los equipos que trabajan directamente con familias y comunidades.\n\nSesión en español con traducción en vivo al inglés.',
        registerHref: 'https://luma.com/il7kc91b',
      },
      {
        title:
          'Familiarizándote con los Datos (y por qué no es tan aterrador como crees)',
        imageNumber: 12,
        time: '11:00 AM ET / 12:00 PYT',
        description:
          'Los datos pueden resultar intimidantes: técnicos, abstractos y reservados para expertos. Pero, en esencia, los datos son simplemente evidencia: hechos, observaciones, conversaciones, respuestas a encuestas, patrones e historias que pueden ayudarnos a comprender mejor a las personas y comunidades a las que servimos.\n\nEn esta sesión, Ibrahima Ball, analista de datos de programas internacionales en Unbound, y Davide Gallo, fundador de Vetta, explorarán cómo las organizaciones de la sociedad civil pueden ganar confianza en el uso de datos sin perder de vista las realidades humanas que hay detrás de ellos.\n\nBasándose en la experiencia de Ibrahima al conectar los datos de los programas con las vivencias de las familias, y en el trabajo de Davide ayudando a emprendedores a usar la IA para probar ideas y construir de manera más efectiva, la conversación mostrará cómo los datos pueden convertirse en una herramienta práctica para el aprendizaje, la toma de decisiones y el impacto.\n\nJuntos, debatirán sobre cómo empezar con preguntas significativas, interpretar la evidencia con contexto, evitar trampas comunes y utilizar los datos para poner a prueba suposiciones en lugar de seguirlos a ciegas. Los participantes se irán con un enfoque simple y centrado en el ser humano para el uso de datos: preguntar, buscar evidencia, interpretar con contexto, decidir y aprender.\n\nSesión en inglés con traducción en vivo al español.',
        registerHref: 'https://luma.com/t2uhdhvb',
      },
      {
        title: 'Ecosistema de Innovación Tecnológica en América Latina',
        imageNumber: 13,
        time: '1:00 PM ET / 14:00 PYT',
        description:
          'Esta sesión explora la evolución del ecosistema de innovación tecnológica en América Latina, con un enfoque en el emprendimiento, la inversión y las tendencias regionales.\n\nEn conversación con Julia Corvalan, Gabi Cibils y Vivianne Bernardes de Cibils, de Cibersons, compartirán perspectivas de su trabajo en capital de riesgo, tecnología e innovación transfronteriza.\n\nVivianne aporta más de 35 años de experiencia como pionera tecnológica, inversora, emprendedora en serie y cofundadora de Cibersons, una firma multinacional de tecnología e inversión. Gabi, quien gestiona el capital de riesgo en Cibersons, aporta su experiencia en el ecosistema tecnológico de Paraguay, las empresas emergentes (startups) e inversores de Silicon Valley, y la inversión en etapas tempranas en toda América.\n\nJuntos, analizarán las oportunidades, los desafíos y las colaboraciones que están configurando el futuro de la innovación tecnológica en América Latina.\n\nSesión en español con traducción en vivo al inglés.',
        registerHref: 'https://luma.com/2g63q08g',
      },
    ],
  },
  {
    date: 'Viernes 10 de julio',
    sessions: [
      {
        title: 'Conversación de "Mesa de Cocina" de Aspen Global Innovators',
        imageNumber: 14,
        time: '8:00 AM ET / 9:00 PYT',
        description:
          'Esta conversación íntima estilo "mesa de cocina" (kitchen table conversation) reúne a becarios de Aspen New Voices para un intercambio sincero sobre lo que está sucediendo en los sectores del desarrollo global y el impacto social, y dónde están encontrando esperanza.\n\nConvocada por Julia Corvalan, del Poverty Stoplight, la sesión contará con Elsa D’Silva (Red Dot Foundation/Safecity), Sathya Raghu (Soul Forest y Kheyti), Oluseun Onigbinde (BudgIT) y Carl Manlan (AGRA) en un debate intersectorial que abarcará la justicia de género, la seguridad alimentaria, la tecnología cívica, la inclusión financiera, la mitigación de la pobreza y el cambio impulsado por las comunidades.\n\nA partir de su labor en África, Asia, América Latina e instituciones globales, los ponentes reflexionarán sobre los desafíos que definen al sector hoy en día, las innovaciones y movimientos que merecen más atención, y los tipos de liderazgo, colaboración e imaginación necesarios para el camino que queda por delante.\n\nSesión en inglés con traducción en vivo al español.',
        registerHref: 'https://luma.com/mapgjnkk',
      },
      {
        title:
          'Género, Pobreza y el Camino a Seguir: El trabajo de desarrollo y el poder de las microtransformaciones desde abajo hacia arriba',
        imageNumber: 15,
        time: '10:00 AM ET / 11:00 PYT',
        description:
          'Esta conversación explorará la relación entre el género, la pobreza y el cambio social, enfocándose en cómo los enfoques desde abajo hacia arriba (bottom-up) pueden generar "microtransformaciones" significativas en la vida de las personas y sus comunidades.\n\nLa invitada especial, la Profesora Emérita Naila Kabeer de la London School of Economics and Political Science, aportará su reconocida experiencia en género, desarrollo, empoderamiento y justicia social a un debate sobre lo que se necesita para promover prácticas de desarrollo más inclusivas y transformadoras.\n\nEn diálogo con la Dra. Julia Corvalan y con Yvette Torres-Rahman, la sesión examinará cómo el trabajo de desarrollo puede reconocer mejor la autonomía de las mujeres, sus experiencias de vida y sus vías cotidianas para salir de la pobreza.\n\nJuntos, reflexionarán sobre los cambios —grandes y pequeños, individuales y colectivos— que pueden ayudar a construir futuros más equitativos desde las bases.\n\nSesión en inglés con traducción en vivo al español.',
        registerHref: 'https://luma.com/wlkox9om',
      },
    ],
  },
]

const CalendarIcon = () => (
  <svg
    viewBox='0 0 564.47 564.47'
    width='48'
    height='48'
    fill='#177a3e'
    aria-hidden='true'
  >
    <path d='M472.57,78.39h-30.95v20.23c0,32.33-26.31,58.64-58.64,58.64s-58.59-26.31-58.59-58.64v-20.23h-84.29v20.23c0,32.33-26.31,58.64-58.64,58.64s-58.59-26.31-58.59-58.64v-20.23h-30.95c-31.06,0-56.27,25.2-56.27,56.27v344.46c0,31.06,25.2,56.27,56.27,56.27h380.66c31.06,0,56.27-25.2,56.27-56.27V134.66c0-31.06-25.2-56.27-56.27-56.27ZM488.76,468.34c0,15.31-12.44,27.75-27.75,27.75H103.45c-15.31,0-27.75-12.44-27.75-27.75v-235.79c0-15.31,12.44-27.69,27.75-27.69h357.56c15.31,0,27.75,12.38,27.75,27.69v235.79Z' />
    <path d='M181.44,127.75c16.08,0,29.13-13.04,29.13-29.13v-40.46c0-8.01-3.26-15.26-8.51-20.56-5.31-5.25-12.55-8.51-20.62-8.51-16.03,0-29.07,13.04-29.07,29.07v40.46c0,16.08,13.04,29.13,29.07,29.13Z' />
    <path d='M382.97,127.75c16.08,0,29.13-13.04,29.13-29.13v-40.46c0-8.01-3.26-15.26-8.51-20.56-5.31-5.25-12.55-8.51-20.62-8.51-16.03,0-29.07,13.04-29.07,29.07v40.46c0,16.08,13.04,29.13,29.07,29.13Z' />
    <path d='M191.12,246.97h-49.8c-6.36,0-11.55,5.2-11.55,11.55v24.32c0,6.36,5.2,11.5,11.55,11.5h49.8c6.36,0,11.55-5.14,11.55-11.5v-24.32c0-6.36-5.2-11.55-11.55-11.55Z' />
    <path d='M307.13,246.97h-49.8c-6.41,0-11.55,5.2-11.55,11.55v24.32c0,6.36,5.14,11.5,11.55,11.5h49.8c6.36,0,11.55-5.14,11.55-11.5v-24.32c0-6.36-5.2-11.55-11.55-11.55Z' />
    <path d='M423.15,246.97h-49.8c-6.41,0-11.55,5.2-11.55,11.55v24.32c0,6.36,5.14,11.5,11.55,11.5h49.8c6.36,0,11.55-5.14,11.55-11.5v-24.32c0-6.36-5.2-11.55-11.55-11.55Z' />
    <rect
      x='129.76'
      y='326.73'
      width='72.9'
      height='47.42'
      rx='11.55'
      ry='11.55'
    />
    <path d='M307.13,326.73h-49.8c-6.41,0-11.55,5.2-11.55,11.55v24.32c0,6.36,5.14,11.55,11.55,11.55h49.8c6.36,0,11.55-5.2,11.55-11.55v-24.32c0-6.36-5.2-11.55-11.55-11.55Z' />
    <path d='M423.15,326.73h-49.8c-6.41,0-11.55,5.2-11.55,11.55v24.32c0,6.36,5.14,11.55,11.55,11.55h49.8c6.36,0,11.55-5.2,11.55-11.55v-24.32c0-6.36-5.2-11.55-11.55-11.55Z' />
    <path d='M191.12,406.54h-49.8c-6.36,0-11.55,5.14-11.55,11.55v24.32c0,6.36,5.2,11.5,11.55,11.5h49.8c6.36,0,11.55-5.14,11.55-11.5v-24.32c0-6.41-5.2-11.55-11.55-11.55Z' />
    <path d='M307.13,406.54h-49.8c-6.41,0-11.55,5.14-11.55,11.55v24.32c0,6.36,5.14,11.5,11.55,11.5h49.8c6.36,0,11.55-5.14,11.55-11.5v-24.32c0-6.41-5.2-11.55-11.55-11.55Z' />
    <path d='M423.15,406.54h-49.8c-6.41,0-11.55,5.14-11.55,11.55v24.32c0,6.36,5.14,11.5,11.55,11.5h49.8c6.36,0,11.55-5.14,11.55-11.5v-24.32c0-6.41-5.2-11.55-11.55-11.55Z' />
  </svg>
)

const ClockIcon = () => (
  <svg
    viewBox='0 0 564.47 564.47'
    width='18'
    height='18'
    fill='#177a3e'
    aria-hidden='true'
    className='iw-clock-icon'
  >
    <path d='M282.21,25.24C140.31,25.24,25.27,140.33,25.27,282.23s115.04,256.99,256.94,256.99,256.99-115.04,256.99-256.99S424.16,25.24,282.21,25.24ZM282.21,510.29c-125.95,0-228.06-102.11-228.06-228.06S156.26,54.17,282.21,54.17s228.06,102.11,228.06,228.06-102.11,228.06-228.06,228.06Z' />
    <path d='M282.21,83.24c-109.88,0-198.99,89.11-198.99,198.99s89.11,198.99,198.99,198.99,198.99-89.06,198.99-198.99-89.06-198.99-198.99-198.99ZM308.93,291.46l-7.15-2.46c-2.8,8.17-10.49,13.97-19.57,13.97-11.45,0-20.73-9.28-20.73-20.73,0-2.56.48-4.98,1.35-7.25l-15.51-5.8-82.78-104.62,104.62,82.78,5.8,15.51c2.22-.87,4.69-1.35,7.25-1.35,7.3,0,13.72,3.77,17.4,9.47l6.33-4.06,99.98.34-96.98,24.21Z' />
  </svg>
)

const PointerIcon = () => (
  <img
    src='https://a.storyblok.com/f/42340/300x300/e9147fa833/icono-12.svg'
    alt='Regístrate en la sesión de Poverty Stoplight Innovation Week'
    className='iw-pointer-icon'
  />
)

const CloseIcon = () => (
  <svg viewBox='0 0 24 24' width='20' height='20' aria-hidden='true'>
    <path
      fill='currentColor'
      d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
    />
  </svg>
)

class SessionLightbox extends React.Component {
  constructor(props) {
    super(props)

    this.state = { closing: false }

    this.handleClose = this.handleClose.bind(this)
    this.handleOverlayClick = this.handleOverlayClick.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  componentDidMount() {
    if (typeof document !== 'undefined') {
      document.body.style.overflow = 'hidden'
    }
  }

  componentWillUnmount() {
    if (this.closeTimer) window.clearTimeout(this.closeTimer)
    if (typeof document !== 'undefined') {
      document.body.style.overflow = ''
    }
  }

  handleClose() {
    this.setState({ closing: true })
    this.closeTimer = window.setTimeout(() => {
      this.props.onClose()
    }, 220)
  }

  handleOverlayClick(event) {
    if (event.target === event.currentTarget) {
      this.handleClose()
    }
  }

  handleKeyDown(event) {
    if (event.key === 'Escape') {
      this.handleClose()
    }
  }

  render() {
    const { session } = this.props
    const { closing } = this.state

    if (!session) return null

    const descriptionText = session.description || ''
    const paragraphs = descriptionText.split(/\n+/).filter(Boolean)
    const lightboxLastParagraph = paragraphs[paragraphs.length - 1] || ''
    const lightboxLanguageInfo = lightboxLastParagraph

    return (
      <div
        className={`iw-lightbox-overlay${closing ? ' iw-lightbox-overlay--closing' : ''}`}
        onClick={this.handleOverlayClick}
        onKeyDown={this.handleKeyDown}
        role='dialog'
        aria-modal='true'
        aria-labelledby='iw-lightbox-title'
        tabIndex={-1}
      >
        <div
          className={`iw-lightbox iw-lightbox--no-image${closing ? ' iw-lightbox--closing' : ''}`}
          role='document'
        >
          <button
            type='button'
            className='iw-lightbox__close'
            onClick={this.handleClose}
            aria-label='Cerrar'
          >
            <CloseIcon />
          </button>

          <div className='iw-lightbox__body'>
            {session.time ? (
              <span className='iw-lightbox__time-pill'>
                <ClockIcon />
                {session.time}
              </span>
            ) : null}

            <h2 id='iw-lightbox-title' className='iw-lightbox__title'>
              {session.title}
            </h2>

            <div className='iw-lightbox__description'>
              <p className='iw-lightbox__description-label'>Descripción</p>
              {paragraphs.map((paragraph, index) =>
                lightboxLanguageInfo &&
                index === paragraphs.length - 1 ? null : (
                  <p
                    key={`lb-p-${index}`}
                    className='iw-lightbox__description-text'
                  >
                    {paragraph}
                  </p>
                ),
              )}
            </div>

            {lightboxLanguageInfo ? (
              <div className='iw-session-language'>
                <div className='iw-session-language-content'>
                  <span className='iw-session-language-primary'>
                    {lightboxLanguageInfo}
                  </span>
                </div>
              </div>
            ) : null}

            <div className='iw-lightbox__actions'>
              <a
                className='iw-register-btn-wrap'
                href={session.registerHref}
                target='_blank'
                rel='noopener noreferrer'
              >
                <span className='iw-register-btn'>
                  Haz clic aquí para registrarte
                </span>
                <PointerIcon />
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

class InnovationWeekEs extends React.Component {
  constructor(props) {
    super(props)
    this.state = { activeSession: null }
    this.openSession = this.openSession.bind(this)
    this.closeSession = this.closeSession.bind(this)
  }

  openSession(session) {
    this.setState({ activeSession: session })
  }

  closeSession() {
    this.setState({ activeSession: null })
  }

  renderSessionCard(session, key, sessionNumber) {
    const description = session.description || ''
    const words = description.split(/\s+/).filter(Boolean)
    const hasLongDescription = words.length > 50
    const paragraphs = description.split(/\n+/).filter(Boolean)
    const sessionImage =
      SESSION_IMAGES[session.imageNumber] || SESSION_IMAGES[1]

    const lastParagraph = paragraphs[paragraphs.length - 1] || ''
    const languageInfo = lastParagraph

    return (
      <article key={key} className='iw-session'>
        <div className='iw-session-image-wrap'>
          <img
            className='iw-session-image'
            src={sessionImage}
            alt={session.title}
          />
        </div>
        <div className='iw-session-body'>
          <h3 className='iw-session-title'>{session.title}</h3>

          {session.time ? (
            <div className='iw-session-time-pill'>
              <ClockIcon />
              <span>{session.time}</span>
            </div>
          ) : null}

          {description ? (
            <div className='iw-session-description-preview'>
              <p className='iw-session-description-label'>Descripción</p>
              {(() => {
                let remainingWords = 50
                let truncated = false
                return paragraphs
                  .map((paragraph, index) => {
                    if (truncated) return null
                    const paragraphWords = paragraph
                      .split(/\s+/)
                      .filter(Boolean)
                    let displayed = paragraph
                    let isTruncated = false
                    if (hasLongDescription) {
                      if (paragraphWords.length <= remainingWords) {
                        remainingWords -= paragraphWords.length
                      } else {
                        displayed = paragraphWords
                          .slice(0, remainingWords)
                          .join(' ')
                        isTruncated = true
                        truncated = true
                      }
                    }
                    return (
                      <p
                        key={`card-p-${index}`}
                        className='iw-session-description-text'
                      >
                        {displayed}
                        {isTruncated ? (
                          <span className='iw-session-description-ellipsis'>
                            {displayed.endsWith('.') ? '…' : ' …'}
                          </span>
                        ) : null}
                      </p>
                    )
                  })
                  .filter(Boolean)
              })()}
            </div>
          ) : null}

          {languageInfo ? (
            <div className='iw-session-language'>
              <div className='iw-session-language-content'>
                <span className='iw-session-language-primary'>
                  {languageInfo}
                </span>
              </div>
            </div>
          ) : null}

          <div className='iw-session-actions'>
            {hasLongDescription ? (
              <button
                type='button'
                className='iw-read-more-btn'
                onClick={() => this.openSession(session)}
              >
                Leer más
                <svg
                  viewBox='0 0 24 24'
                  width='14'
                  height='14'
                  aria-hidden='true'
                >
                  <path
                    fill='currentColor'
                    d='M5 12h12.17l-3.58-3.59L15 7l6 6-6 6-1.41-1.41L17.17 14H5z'
                  />
                </svg>
              </button>
            ) : null}

            <a
              className='iw-register-btn-wrap iw-register-btn-wrap--inline'
              href={session.registerHref}
              target='_blank'
              rel='noopener noreferrer'
            >
              <span className='iw-register-btn'>
                Haz clic aquí para registrarte
              </span>
              <PointerIcon />
            </a>
          </div>
        </div>
      </article>
    )
  }

  renderDay(day, key, sessionOffset) {
    return (
      <section key={key} className='iw-day'>
        <header className='iw-day-header'>
          <span className='iw-day-icon'>
            <CalendarIcon />
          </span>
          <h2 className='iw-day-date'>{day.date}</h2>
        </header>
        <div className='iw-sessions'>
          {day.sessions.map((session, index) =>
            this.renderSessionCard(
              session,
              `${key}-session-${index}`,
              sessionOffset + index + 1,
            ),
          )}
        </div>
      </section>
    )
  }

  render() {
    const storyName = this.props.story && this.props.story.name
    const title = storyName || 'Semana de la Innovación 2026'
    const pageTitle = `${title} | Poverty Stoplight`
    const description =
      'Acompáñanos en la Poverty Stoplight Innovation Week 2026 (6–10 de julio), un evento virtual y gratuito con la Red Global del Semáforo para debatir sobre datos y storytelling, tecnología e IA, y la eliminación de la pobreza en el mundo.'
    const keywords =
      'Poverty Stoplight, Semana de la Innovación, Innovation Week 2026, eliminación de la pobreza, innovación social, tecnología cívica, IA para el bien, Red Global del Semáforo, Fundación Paraguaya, storytelling de datos'
    const canonicalUrl = 'https://www.povertystoplight.org/es/innovation-week'
    const ogImage =
      'https://a.storyblok.com/f/42340/2000x666/0e6d3a9263/innovation_week.jpg'

    const eventStructuredData = {
      '@context': 'https://schema.org',
      '@type': 'Event',
      name: title,
      description,
      startDate: '2026-07-06',
      endDate: '2026-07-10',
      eventAttendanceMode: 'https://schema.org/OnlineEventAttendanceMode',
      eventStatus: 'https://schema.org/EventScheduled',
      image: ogImage,
      url: canonicalUrl,
      location: {
        '@type': 'VirtualLocation',
        url: canonicalUrl,
      },
      organizer: {
        '@type': 'Organization',
        name: 'Poverty Stoplight',
        url: 'https://www.povertystoplight.org',
      },
    }

    const { activeSession } = this.state

    return (
      <div className='innovation-page'>
        <Helmet>
          <title>{pageTitle}</title>
          <meta name='description' content={description} />
          <meta name='keywords' content={keywords} />
          <link rel='canonical' href={canonicalUrl} />

          <meta property='og:type' content='website' />
          <meta property='og:site_name' content='Poverty Stoplight' />
          <meta property='og:title' content={pageTitle} />
          <meta property='og:description' content={description} />
          <meta property='og:url' content={canonicalUrl} />
          <meta property='og:image' content={ogImage} />
          <meta property='og:image:width' content='2000' />
          <meta property='og:image:height' content='666' />
          <meta
            property='og:image:alt'
            content='Poverty Stoplight Innovation Week'
          />

          <meta name='twitter:card' content='summary_large_image' />
          <meta name='twitter:title' content={pageTitle} />
          <meta name='twitter:description' content={description} />
          <meta name='twitter:image' content={ogImage} />

          <script type='application/ld+json'>
            {JSON.stringify(eventStructuredData)}
          </script>
        </Helmet>

        <section className='iw-banner'>
          <img
            className='iw-banner__image'
            src='https://a.storyblok.com/f/42340/2000x666/0e6d3a9263/innovation_week.jpg'
            alt='Poverty Stoplight Innovation Week'
          />
        </section>

        <main className='iw-content'>
          <h1 className='iw-visually-hidden'>
            {title}: Poverty Stoplight Innovation Week, 6–10 de julio de 2026
          </h1>
          <div className='iw-intro'>
            <p className='iw-intro-text'>
              Acompáñanos en una semana emocionante junto a la{' '}
              <strong>
                Red Global del Poverty Stoplight (Global Stoplight Network)
              </strong>{' '}
              para debatir sobre las últimas tendencias en datos y narración de
              historias (storytelling), tecnología e inteligencia artificial, y
              la eliminación de la pobreza en todo el mundo.
            </p>
            <div className='iw-intro-pill iw-intro-pill--translation'>
              <span className='iw-intro-pill-line'>
                ¡Sesiones en español e inglés, con traducción simultánea en
                todos los eventos!
              </span>
            </div>
            <div className='iw-intro-pill'>
              <span className='iw-intro-pill-line'>
                Del lunes 6 al viernes 10 de julio
              </span>
              <span className='iw-intro-pill-sub'>
                Virtual y abierto al público
              </span>
            </div>
          </div>

          <div className='iw-agenda'>
            {
              AGENDA.reduce(
                (acc, day, index) => {
                  const element = this.renderDay(
                    day,
                    `agenda-day-${index}`,
                    acc.offset,
                  )
                  acc.elements.push(element)
                  acc.offset += day.sessions.length
                  return acc
                },
                { elements: [], offset: 0 },
              ).elements
            }
          </div>
        </main>

        {activeSession ? (
          <SessionLightbox
            session={activeSession}
            onClose={this.closeSession}
          />
        ) : null}
      </div>
    )
  }
}

export default withRouteData(InnovationWeekEs)



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/InnovationWeekEs.js